<template>
  <div>
    <transition name="slide">
      <div class="notification" v-if="myShow" :style="setStyle">
        <div class="delete" v-if="!myOptions.autoClose" @click="close()"></div>
        <div class="content" v-html="myOptions.content"></div>
      </div>
    </transition>
    <div
      class="countdown"
      v-if="myShow && myOptions.autoClose && myOptions.countdownBar"
      :style="setTime"
      :class="barControl"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timers: [],
      barControl: "",
      myOptions: this.options,
      myShow: this.show
    };
  },
  props: {
    options: {
      type: Object,
      default: {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    setStyle() {
      return {
        color: this.myOptions.textColor || "#fff",
        background: this.myOptions.backgroundColor || "#21e7b6"
      };
    },
    setTime() {
      return {
        transition: `all ${this.myOptions.showTime / 1000 || 2}s linear`,
        background: this.myOptions.barColor || "#03D6D2"
      };
    }
  },
  methods: {
    countdown() {
      if (this.myOptions.autoClose) {
        if (this.myOptions.countdownBar) {
          setTimeout(() => {
            this.barControl = "count-leave";
          }, 10);
        }
        let t = null;
        // 需要跳转时候，跳转快一点，以防多次报单
        if (this.myOptions.jumpUrl) {
          t = setTimeout(() => {
            //带参数
            if (this.myOptions.jumpParams) {
              this.$router.push({
                path: this.myOptions.jumpUrl,
                query: this.myOptions.jumpParams
              });
            } else {
              this.$router.push(this.myOptions.jumpUrl);
            }
            this.close();
          }, this.myOptions.showTime || 500);
        } else {
          // 不需要跳转的时候，跳转慢一点，展示提示信息
          t = setTimeout(() => {
            this.close();
          }, this.myOptions.showTime || 3000);
        }
        this.timers.push(t);
      }
    },
    close() {
      this.$emit("close"); // should to emit to change parent components status
      this.myOptions = {};
    }
  },
  watch: {
    options() {
      //根据prop options 重新组织数据
      let options = {};

      let jumpUrl = "";
      if (this.options.jumpUrl) {
        jumpUrl = this.options.jumpUrl;
      }
      let jumpParams = "";
      if (this.options.jumpParams) {
        jumpParams = this.options.jumpParams;
      }
      if (this.options.code == 0) {
        options = {
          autoClose: true,
          content: this.options.msg,
          backgroundColor: "#FFFFFF",
          textColor: "#333333",
          jumpUrl: jumpUrl,
          jumpParams: jumpParams
        };
      } else if (this.options.code > 0) {
        options = {
          autoClose: true,
          content: this.options.msg,
          backgroundColor: "#F7534F",
          textColor: "#fff",
          jumpUrl: jumpUrl,
          jumpParams: jumpParams
        };
      } else {
        options = {
          autoClose: true,
          content: this.options.msg,
          backgroundColor: "#769FCD",
          textColor: "#92253f",
          jumpUrl: jumpUrl,
          jumpParams: jumpParams
        };
      }

      //根据prop options 重新组织数据 修改 this.myOptions = this.options

      this.myOptions = options;
      this.barControl = "";
      this.timers.forEach(timer => {
        window.clearTimeout(timer);
      });
      this.timers = [];
      this.countdown();
    },
    show(val) {
      this.myShow = val;
    }
  }
};
</script>

<style scoped>
.slide-transition {
  transition: all 0.3s ease;
  transform: translateZ(0);
}

.slide-active-enter,
.slide-active-leave {
  transform: translate3d(0, -100%, 0);
}

/*
    .slide-enter-active, .slide-leave-active {
    transition: all .3s ease;
    transform: translate3d(0, -100%, 0);
  }
  .slide-enter, .slide-leave-to {
    transform: translateZ(0);
  }

  */

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
  transform: translateZ(0);
}

.slide-enter,
.slide-leave-active {
  transform: translate3d(0, -100%, 0);
}

.delete {
  -moz-appearance: none;
  -webkit-appearance: none;
  background: rgba(51, 51, 51, 0.2);
  cursor: pointer;
  display: inline-block;
  height: 24px;
  position: relative;
  vertical-align: top;
  width: 24px;
  float: right;
}

.delete:after,
.delete:before {
  background: #fff;
  content: "";
  display: block;
  height: 2px;
  left: 50%;
  margin-left: -25%;
  margin-top: -1px;
  position: absolute;
  top: 50%;
  width: 50%;
}

.delete:before {
  transform: rotate(45deg);
}

.delete:after {
  transform: rotate(-45deg);
}

.delete:hover {
  background: rgba(51, 51, 51, 0.5);
}

.notification {
  width: 100%;
  line-height: 2;
  z-index: 3000;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
}

.notification .content {
  text-align: center;
  padding: 13px 5px;
  font-size: 15px;
}

.countdown {
  width: 100%;
  height: 4px;
  background: #000;
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateZ(0);
}

.count-leave {
  transform: translate3d(-100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Notification.vue